import DeclaracionConjuntaForm from './DeclaracionConjuntaForm';

export default {
  install: (app, _options) => {
    app.component('Modelo182DeclaracionConjuntaForm', DeclaracionConjuntaForm);
  },
};
